import { useInfiniteQuery } from "@tanstack/react-query";
import {
  fetchPotentialSupervisors,
  PotentialSupervisorsResponse,
} from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api";

interface UseFetchPotentialSupervisorsParams {
  companyId: string;
  employeeId: string;
  query?: string;
  enabled?: boolean;
}

const useFetchPotentialSupervisors = ({
  companyId,
  employeeId,
  query,
  enabled = true,
}: UseFetchPotentialSupervisorsParams) => {
  let filters: string | null = null;

  const normalizedQuery = query?.trim();

  if (normalizedQuery) {
    const [firstPhrase, secondPhrase] = normalizedQuery.split(" ");

    if (secondPhrase) {
      filters = `(firstName=like=*${firstPhrase}*;lastName=like=*${secondPhrase}*),(firstName=like=*${secondPhrase}*;lastName=like=*${firstPhrase}*)`;
    } else {
      filters = `(firstName=like=*${firstPhrase}*,lastName=like=*${firstPhrase}*)`;
    }
  }

  return useInfiniteQuery<PotentialSupervisorsResponse, Error>({
    queryKey: ["fetch-potential-supervisors", companyId, employeeId, query],
    queryFn: async ({ pageParam, signal }) => {
      const data = await fetchPotentialSupervisors(companyId, employeeId, {
        signal,
        nextCursor: pageParam,
        query: filters,
      });
      return data;
    },
    enabled: enabled && !!companyId && !!employeeId,
    initialPageParam: null,
    getNextPageParam: (lastPage) => lastPage.nextCursor || null,
    placeholderData: (previousData) =>
      previousData ?? { pages: [], pageParams: [] },
  });
};

export default useFetchPotentialSupervisors;
